import React from 'react';
import { IconCampaign, IconMetrics } from '../../icons';
import { ChipNew, ChipNewText, IconSquareButtonNewStyled } from './style';

interface IProps {
  icon?: 'IconCampaign';
  label?: string;
  id: string;
  onClick: () => void;
  chip: boolean;
}

const getIconSvg = (icon?: string) => {
  switch (icon) {
    case 'IconCampaign':
      return <IconCampaign className="ButtonNavigation-center-icon" />;
    case 'IconMetrics':
      return <IconMetrics className="ButtonNavigation-center-icon" />;
    default:
      return null;
  }
};

const SquareButtonNew = (props: IProps) => {
  const { icon, label, onClick, id, chip } = props;
  return (
    <IconSquareButtonNewStyled id={id} className="itemsMenu" onClick={onClick}>
      {chip && (
        <ChipNew>
          <ChipNewText>Nuevo</ChipNewText>
        </ChipNew>
      )}

      {getIconSvg(icon)}
      <br />
      {label}
    </IconSquareButtonNewStyled>
  );
};

export default SquareButtonNew;
